import { X, Save } from "lucide-react";

const CreateLevelModal = ({ t, styles, formData, setFormData, onSubmit, onClose, loading }) => (
  <div style={styles.modal} onClick={onClose}>
    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
      <div style={styles.modalHeader}>
        <h2 style={styles.modalTitle}>{t.createAdminLevel}</h2>
        <button style={styles.iconButton} onClick={onClose}><X size={24} /></button>
      </div>
      <form onSubmit={onSubmit}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>{t.name}</label>
          <input
            type="text" value={formData.name} required
            onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
            placeholder={t.namePlaceholder} style={styles.input}
          />
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>{t.description}</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData((p) => ({ ...p, description: e.target.value }))}
            placeholder={t.descPlaceholder}
            style={{ ...styles.input, minHeight: "100px", resize: "vertical" }}
          />
        </div>
        <div style={styles.modalFooter}>
          <button type="submit" disabled={loading} style={{ ...styles.button, ...styles.primaryButton }}>
            <Save size={18} /> {t.create}
          </button>
          <button type="button" onClick={onClose} style={{ ...styles.button, ...styles.secondaryButton }}>
            {t.cancel}
          </button>
        </div>
      </form>
    </div>
  </div>
);

export default CreateLevelModal;